import React, { Component } from 'react';
import TextFields from '../UI/TextField-f';
import SelectMenu from '../UI/Select-f';
import CheckboxElement from '../UI/CheckboxField'
import SwitchToggle from '../UI/SwitchToggle-f';
import Spinner from '../UI/Spinner';
import { getCustomer, editCustomer } from '../../actions'
import { connect } from 'react-redux';
import { Formik, Form } from 'formik'

const HOURS = [
    {key: '00:00', value: '00:00'},
    {key: '01:00', value: '01:00'},
    {key: '02:00', value: '02:00'},
    {key: '03:00', value: '03:00'},
    {key: '04:00', value: '04:00'},
    {key: '05:00', value: '05:00'},
    {key: '06:00', value: '06:00'},
    {key: '07:00', value: '07:00'},
    {key: '08:00', value: '08:00'},
    {key: '09:00', value: '09:00'},
    {key: '10:00', value: '10:00'},
    {key: '11:00', value: '11:00'},
    {key: '12:00', value: '12:00'},
    {key: '13:00', value: '13:00'},
    {key: '14:00', value: '14:00'},
    {key: '15:00', value: '15:00'},
    {key: '16:00', value: '16:00'},
    {key: '17:00', value: '17:00'},
    {key: '18:00', value: '18:00'},
    {key: '19:00', value: '19:00'},
    {key: '20:00', value: '20:00'},
    {key: '21:00', value: '21:00'},
    {key: '22:00', value: '22:00'},
    {key: '23:00', value: '23:00'},
];


const WEEKDAYS_MAP = {
    "1": "Sunday",
    "2": "Monday",
    "3": "Tuesday",
    "4": "Wednesday",
    "5": "Thursday",
    "6": "Friday",
    "7": "Saturday",
};
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ];


const getWeekdays = openingHours => {
    let weekdays = {};
    for (const key in openingHours) {
        weekdays[WEEKDAYS_MAP[openingHours[key].weekday]] = true;
    }
    return weekdays;
};

const shapeBranches = branches => {
    let branchesData = {};
    for (const key in branches) {
        branchesData[`${key}_`] = branches[key].isActive
    }
    return branchesData;
};

const WEEKDAYS = [
    {id: 1, value: 'Sunday', field: 'sunday'},
    {id: 2, value: 'Monday', field: 'monday'},
    {id: 3, value: 'Tuesday', field: 'tuesday'},
    {id: 4, value: 'Wednesday', field: 'wednesday'},
    {id: 5, value: 'Thursday', field: 'thursday'},
    {id: 6, value: 'Friday', field: 'friday'},
    {id: 7, value: 'Saturday', field: 'saturday'}
];

class CustomerGeneral extends Component {

    state = {
        error: null
    }

    componentDidMount() {
        this.props.getCustomer();
    }

    getWeekdayStatus = id =>{
        let status = false;
        for (const key in this.props.data.openingHours) {
            if (id === this.props.data.openingHours[key].weekday) {
                status = true;
                break;
            }
        }
        return status;
    };

    onSubmitFormHandler = (submittedValues) => {
        const data = {
            id: this.props.data.result
        };
        const weekdays = WEEKDAYS.filter(weekday => submittedValues.weekdays[weekday.value]);
        const opening_hours = weekdays.map(weekday => {
            return {
                weekday: weekday.id,
                from_hour: this.convertByTimeZone(submittedValues.from_hour),
                to_hour: this.convertByTimeZone(submittedValues.to_hour),
            };
        });

        if (opening_hours) {
            data.restaurant = {};
            data.restaurant.opening_hours = opening_hours
        }

        if (submittedValues.branches_data) {
            const branches = Object.keys(submittedValues.branches_data).map(branch => {
                return ({
                    id: parseInt(branch, 10),
                    is_active: submittedValues.branches_data[branch]
                });
            });
            if (data.restaurant) {
                data.restaurant.branches = branches;
            } else {
                data.restaurant = {};
                data.restaurant.branches = branches;
            }

        }
        this.props.editCustomer(data).then(res => this.props.getCustomer()).catch(err => {
            if(err && err.response && err.response.data && err.response.data.errors && err.response.data.errors[0].message.includes('have a active order')) {
                this.props.getCustomer().then(res => this.setState({error: err.response.data.errors[0].message}))

            }
        })
    };

    convertByTimeZone = (time, isZone) => {

        const HOURS = [
            { key: "01:00", value: 1 },
            { key: "02:00", value: 2 },
            { key: "03:00", value: 3 },
            { key: "04:00", value: 4 },
            { key: "05:00", value: 5 },
            { key: "06:00", value: 6 },
            { key: "07:00", value: 7 },
            { key: "08:00", value: 8 },
            { key: "09:00", value: 9 },
            { key: "10:00", value: 10 },
            { key: "11:00", value: 11 },
            { key: "12:00", value: 12 },
            { key: "13:00", value: 13 },
            { key: "14:00", value: 14 },
            { key: "15:00", value: 15 },
            { key: "16:00", value: 16 },
            { key: "17:00", value: 17 },
            { key: "18:00", value: 18 },
            { key: "19:00", value: 19 },
            { key: "20:00", value: 20 },
            { key: "21:00", value: 21 },
            { key: "22:00", value: 22 },
            { key: "23:00", value: 23 },
            { key: "00:00", value: 24 }
        ];
        const hourVal = HOURS.find(hour => hour.key === time);
        const hrs = -(new Date().getTimezoneOffset() / 60);
        let convertedTime;
        if(isZone) {
            convertedTime = hourVal.value + hrs;
        } else {
            convertedTime = hourVal.value - hrs;
        }

        if(convertedTime > 24) {
            convertedTime = convertedTime - 24;
        } else if(convertedTime < 0) {
            convertedTime = 24 + convertedTime;
        } else if(convertedTime === 0) {
            convertedTime = 24;
        }

        convertedTime = HOURS.find(hour => hour.value === convertedTime);
        return convertedTime.key;
    };

    render() {
        if (!this.props.data || !this.props.data.customers) return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-12">
                                <h1 className="color-grey capitalize">General Settings</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container box inner-padding mb-15">

                    <div className="box-body"><Spinner/></div>
                </div>
            </React.Fragment>
        );
        const { openingHours } = this.props.data;
        const openHoursId = Object.keys(openingHours)[0];
        const openHoursFrom = this.convertByTimeZone(openingHours[openHoursId].fromHour.substr(0,5), true);
        const openHoursTo = this.convertByTimeZone(openingHours[openHoursId].toHour.substr(0,5), true);

        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-12">
                                <h1 className="color-grey capitalize">General Settings</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container box inner-padding mb-15">
                    <Formik
                        initialValues={{
                            from_hour: openHoursFrom,
                            to_hour: openHoursTo,
                            weekdays: (this.props.data.openingHours && getWeekdays(this.props.data.openingHours)) || {},
                            branches_data: (this.props.data.branches && shapeBranches(this.props.data.branches)) || {}
                        }}

                        onSubmit={ (values) => this.onSubmitFormHandler(values) }
                        render={({ values, touched, setFieldValue }) => (
                            <Form>
                                <div className="box-body">

                                    <div className="row justify-between">
                                        <div className="col-xs-6 pr-70">
                                            <div className="row">
                                                <div className="col-xs-12 mt-20 ">
                                                    <p className="color-grey50 font-sm w-700">Open Hours</p>
                                                </div>
                                                <div className="col-xs-6">
                                                    <SelectMenu value={values.from_hour}
                                                                name="from_hour"
                                                                floatingLabelText="from"
                                                                onChange={setFieldValue}
                                                                menu={ HOURS }/>
                                                </div>
                                                <div className="col-xs-6">
                                                    <SelectMenu value={values.to_hour}
                                                                name="to_hour"
                                                                floatingLabelText="to"
                                                                onChange={setFieldValue}
                                                                menu={ HOURS }/>
                                                </div>
                                            </div>
                                            <div className="mt-25">
                                                <p className="color-grey50 font-sm w-700 pb-10">Open Days</p>
                                                <ul className="flex wrap">
                                                    {
                                                        DAYS.map(day => {
                                                            return (
                                                                <li className="mr-25 py-5" key={day}>
                                                                    <label className="flex-center-y pointer w-600">
                                                                        <CheckboxElement name={ `weekdays.${day}` }
                                                                                         value={ values.weekdays && values.weekdays[day] }
                                                                                         onChange={ setFieldValue }
                                                                                         label={day} />
                                                                    </label>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                            {
                                                this.props.data.branches && Object.keys(this.props.data.branches).map((branchId, index) => {
                                                    const branch = this.props.data.branches[branchId];
                                                    return (
                                                        <div className="row align-end" key={branchId}>
                                                            <div className="col-xs-7">
                                                                <TextFields disabled
                                                                            value={branch.address}
                                                                            type="text"
                                                                            label={"Customer Branch Location " + (index + 1)}
                                                                            name="customer_branch_location" />
                                                            </div>
                                                            <div className="col-xs-5">
                                                                <div className="flex-center-y justify-end">
                                                                    <span className="color-grey50 w-600 mr-15">Inactive</span>
                                                                    <SwitchToggle name={`branches_data.${branch.id}_`}
                                                                                  value={values.branches_data && values.branches_data[`${branch.id}_`] }
                                                                                  onChange={setFieldValue} />
                                                                    <span className="color-primary w-600 ml-25">Active</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                    <span style={{color: 'red', fontSize: '12px', fontStyle: 'italic'}}>{this.state.error}</span>
                                    <div className="text-right mt-20">
                                        <button type="submit" className="btn filled primary min-180">Save</button>
                                    </div>
                                </div>
                            </Form>
                        )}>

                    </Formik>
                </div>
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => {
    return {
        data: state.foodna
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getCustomer: () => dispatch( getCustomer() ),
        editCustomer: data => dispatch( editCustomer(data) )
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerGeneral);



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/GeneralSettings.js